import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Leaf = ({ svgSize = ICON_SIZES.MD, className = '' }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.6667 15.6667C24.6667 10.0667 20 5.33333 16 3V29C20 26.6667 24.6667 21.2667 24.6667 15.6667Z"
          fill={theme.icon.fill}
        />
        <path
          d="M14.9781 2.84351C15.602 2.44516 16.3993 2.445 17.0231 2.84351C18.8501 4.01081 20.7529 5.63477 22.276 7.59058C23.6965 9.41476 24.8041 11.5509 25.1881 13.8923C25.2832 14.4721 25.3336 15.0646 25.3336 15.6667C25.3335 18.4859 24.2255 21.2169 22.6549 23.5437C21.0828 25.8727 19.0167 27.843 17.026 29.1482C16.4021 29.5572 15.5981 29.5571 14.9742 29.1482C12.9835 27.843 10.9185 25.8727 9.34631 23.5437C7.77554 21.2167 6.66671 18.4862 6.66663 15.6667C6.66664 15.0646 6.71804 14.4721 6.81311 13.8923C7.19717 11.551 8.30381 9.41471 9.72424 7.59058C11.2474 5.63472 13.1511 4.01078 14.9781 2.84351ZM15.3561 4.18823C13.7454 5.2651 12.1014 6.70844 10.777 8.40894C9.45461 10.107 8.46761 12.0408 8.12854 14.1072C8.04468 14.6185 8.00062 15.1394 8.00061 15.6667C8.0007 18.1412 8.97753 20.615 10.4508 22.7976C11.8291 24.8394 13.6162 26.5868 15.3522 27.7937L15.3346 22.614L9.1969 16.6179C8.93367 16.3606 8.9289 15.9389 9.18616 15.6755C9.4435 15.4126 9.86531 15.4076 10.1285 15.6648L15.3375 20.7527L15.3551 13.9236L11.5475 10.2009C11.2843 9.94348 11.2793 9.52079 11.5367 9.25757C11.7942 8.99463 12.217 8.99045 12.4801 9.2478L15.3561 12.0593V4.18823ZM16.6891 12.0505L19.5319 9.24976C19.7941 8.99157 20.2169 8.99445 20.4752 9.25659C20.7333 9.51874 20.7302 9.94059 20.4684 10.199L16.6881 13.9236L16.6705 20.7458L21.8717 15.6648C22.1351 15.4078 22.5578 15.4123 22.8151 15.6755C23.0721 15.9388 23.0664 16.3607 22.8033 16.6179L16.6676 22.613L16.6852 27.7673C18.4094 26.5614 20.181 24.8247 21.5494 22.7976C23.0227 20.615 24.0005 18.1411 24.0006 15.6667C24.0006 15.1394 23.9556 14.6185 23.8717 14.1072C23.5326 12.0408 22.5466 10.107 21.2242 8.40894C19.9122 6.72412 18.2854 5.29317 16.6891 4.21948V12.0505Z"
          fill={theme.icon.stroke}
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.1667 27.4167C43.1667 17.6167 35 9.33333 28 5.25V50.75C35 46.6667 43.1667 37.2167 43.1667 27.4167Z"
        fill={theme.icon.fill}
      />
      <path
        d="M26.3763 5.77917C27.3742 5.17458 28.6255 5.17466 29.6234 5.77917C32.7573 7.67823 36.0854 10.0373 38.7523 13.4618C41.2169 16.6266 43.1281 20.3208 43.7904 24.3583C43.9543 25.3579 44.0413 26.3785 44.0414 27.4159C44.0414 32.2746 42.1313 36.9982 39.4037 41.0389C36.6742 45.0824 33.0871 48.5025 29.6351 50.7655C28.6404 51.4176 27.3593 51.4176 26.3646 50.7655C22.9128 48.5025 19.3264 45.0822 16.597 41.0389C13.8694 36.9982 11.9584 32.2746 11.9584 27.4159C11.9584 26.3785 12.0454 25.3579 12.2094 24.3583C12.8716 20.3208 14.7829 16.6266 17.2474 13.4618C19.9143 10.0373 23.2425 7.67824 26.3763 5.77917ZM27.1635 7.34949C24.1392 9.19103 21.0705 11.4011 18.6283 14.537C16.2925 17.5364 14.54 20.9649 13.9369 24.6415C13.7877 25.5511 13.7084 26.4769 13.7084 27.4159C13.7084 31.8219 15.4475 36.208 18.0472 40.0594C20.5921 43.8294 23.9262 47.0288 27.1254 49.1669V39.451L16.0443 28.6259C15.6989 28.2882 15.6923 27.7342 16.0297 27.3885C16.3673 27.0432 16.9214 27.0365 17.267 27.3739L27.1302 37.0096L27.1625 24.245L19.7123 16.9589C19.3671 16.621 19.3609 16.067 19.6986 15.7216C20.0364 15.3764 20.5905 15.3694 20.9359 15.7069L27.1635 21.7977V7.34949ZM28.9135 21.787L35.0804 15.7098C35.4246 15.371 35.9786 15.3748 36.3177 15.7186C36.6568 16.0627 36.6527 16.6167 36.309 16.9559L28.9125 24.245L28.8802 36.9989L38.7328 27.3739C39.0784 27.0365 39.6324 27.0432 39.9701 27.3885C40.3076 27.7341 40.3018 28.2882 39.9564 28.6259L28.8754 39.451V49.1659C32.0742 47.0278 35.4079 43.829 37.9525 40.0594C40.5523 36.208 42.2914 31.822 42.2914 27.4159C42.2913 26.4769 42.213 25.551 42.0638 24.6415C41.4607 20.9649 39.7073 17.5364 37.3715 14.537C34.95 11.4277 31.9128 9.22851 28.9135 7.39636V21.787Z"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

Leaf.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Leaf;
